import { Box, Container, Typography, Paper } from '@mui/material';

interface LegalPageLayoutProps {
  title: string;
  version: string;
  effectiveDate: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

/**
 * Common layout for legal document pages
 */
export const LegalPageLayout = ({ title, version, effectiveDate, lastUpdated, children }: LegalPageLayoutProps) => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography component="h1" gutterBottom variant="h4">
          {title}
        </Typography>

        {children}

        <Box sx={{ mt: 4, color: 'text.secondary' }}>
          <Typography variant="body2">Versión: {version}</Typography>
          <Typography variant="body2">Vigente desde: {effectiveDate}</Typography>
          {lastUpdated && <Typography variant="body2">Última actualización: {lastUpdated}</Typography>}
        </Box>
      </Paper>
    </Container>
  );
};
